import { reactive } from 'vue';

const userInfo = reactive({});

const setUserInfo = (newUserInfo) => {
  Object.assign(userInfo, newUserInfo);
}

export default { userInfo, setUserInfo };